import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../views/ProtectedRoute';
import AdminLayout from '../views/layout/AdminLayout'
import Dashboard from '../views/Dashboard';
import UserList from '../views/User/List';

import CategoryList from '../views/Category/List';
import DeliveryPartnerList from '../views/DeliveryPartner/List';
import ProductList from '../views/Product/List';
import ViewProductDetail from '../views/Product/ViewDetails';
import CreateUpdateProduct from '../views/Product/CreateUpdateProduct';
import PageList from '../views/Page/List';
import CreateUpdatePage from '../views/Page/CreateUpdatePage';
import EpoojaList from '../views/Epooja/List';
import CreateUpdateEpooja from '../views/Epooja/CreateUpdateProduct';
import ViewEpoojaDetail from '../views/Epooja/ViewDetails';

import KundliPredictionList from '../views/KundliPrediction/List';
import CreateUpdateKundliPrediction from '../views/KundliPrediction/CreateUpdateProduct';
import ViewKundliPredictionDetail from '../views/KundliPrediction/ViewDetails';

import YogaServiceList from '../views/YogaService/List';
import CreateUpdateYogaService from '../views/YogaService/CreateUpdateProduct';
import ViewYogaServiceDetail from '../views/YogaService/ViewDetails';

import ComplaintList from '../views/Complaint/List';
import CancelOrderList from '../views/CancelOrder/List';
import OrderList from '../views/Order/ProductOrderList';
import EpujaOrdersList from '../views/Order/EpujaOrdersList';
import KundliOrdersList from '../views/Order/KundliOrdersList';
import ViewOrderDetail from '../views/Order/ViewDetails';
import OrderInvoice from '../views/Order/OrderInvoice';

import ContactUs from '../views/ContactUs/List';

import SettingList from '../views/Setting/List';
import NewsLettersEmailList from '../views/NewsLettersEmail/List';
import FaqList from '../views/Faq/List';
import BlogList from '../views/Blog/List';
import CreateUpdateBlog from '../views/Blog/CreateUpdateBlog';
import ServiceEnquiryList from '../views/ServiceEnquiry/List';
import CouponList from '../views/Coupon/List';

const ClientRoutes = () => (
	<Route element={<AdminLayout />}>
		<Route path='/dashboard' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <Dashboard />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/users-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <UserList role_id={1}/>
		    </ProtectedRoute>
		  }
		/>
		<Route path='/customers-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <UserList role_id={2}/>
		    </ProtectedRoute>
		  }
		/>
		<Route path='/pandit-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <UserList role_id={3}/>
		    </ProtectedRoute>
		  }
		/>
		<Route path='/settings-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <SettingList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/orders-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <OrderList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/order-detail/:order_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ViewOrderDetail />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/order-invoice/:order_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <OrderInvoice />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/epooja-orders-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <EpujaOrdersList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/kundli-and-prediction-orders-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <KundliOrdersList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/service-enquiry-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ServiceEnquiryList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/complaint-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ComplaintList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/cancel-orders-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CancelOrderList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/delivery-partner-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <DeliveryPartnerList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/coupon-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CouponList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/category-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CategoryList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/product-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ProductList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/product-detail/:product_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ViewProductDetail />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/create-update-product/:product_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CreateUpdateProduct />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/page-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <PageList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/create-update-page/:page_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CreateUpdatePage />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/epuja-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <EpoojaList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/epuja-detail/:product_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ViewEpoojaDetail />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/create-update-epuja/:product_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CreateUpdateEpooja />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/kundli-prediction-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <KundliPredictionList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/kundli-prediction-detail/:product_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ViewKundliPredictionDetail />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/create-update-kundli-prediction/:product_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CreateUpdateKundliPrediction />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/yoga-service-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <YogaServiceList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/yoga-service-detail/:product_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ViewYogaServiceDetail />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/create-update-yoga-service/:product_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CreateUpdateYogaService />
		    </ProtectedRoute>
		  }
		/>
		
		<Route path='/news-letter-email-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <NewsLettersEmailList />
          </ProtectedRoute>
         }
		/>
		<Route path='/contact-us-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <ContactUs />
          </ProtectedRoute>
         }
		/>
		<Route path='/faq-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <FaqList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/blog-list' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <BlogList />
		    </ProtectedRoute>
		  }
		/>
		<Route path='/create-update-blog/:blog_id' 
		  element={
		    <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
			  <CreateUpdateBlog />
		    </ProtectedRoute>
		  }
		/>
	</Route>	
);

export default ClientRoutes;
